import React, { FunctionComponent, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled, { css } from 'styled-components'
import SvgCircle01 from '../generated/svg/circle-01'
import SvgCircle02 from '../generated/svg/circle-02'
import SvgCircle03 from '../generated/svg/circle-03'
import SvgCircle04 from '../generated/svg/circle-04'
import SvgCircle05 from '../generated/svg/circle-05'
import SvgCircle06 from '../generated/svg/circle-06'
import SvgCircle07 from '../generated/svg/circle-07'
import SvgCloseIcon from '../generated/svg/close-icon'
import SvgMenuIcon from '../generated/svg/menu-icon'

const Outer = styled.div``

const ButtonContainer = styled.div`
  z-index: 2;
  position: relative;
  svg {
    height: 1.5rem;
    width: auto;
    display: block;
  }
`

const MenuOuter = styled.div<{open?: boolean}>`
  display: none;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  margin-top: 3rem;
  padding: 4rem 1rem 1rem;
  background-color: #fff;
  gap: 1rem;
  ${({open}) => open && css`
    display: flex;
  `}
`

const SnsIconContainer = styled.div`
  align-self: center;
`

const ItemContainer = styled.div``

const Item = styled(Link)`
  display: flex;
  padding: 1rem 0.5rem;
  gap: 1rem;
`

const DecorationContainer = styled.div`
  svg {
    display: block;
    height: 1rem;
    width: auto;
  }
`

const Label = styled.div`
  font-weight: 700;
`

type MobileHeaderMenuProps = {

}
export const MobileHeaderMenu: FunctionComponent<MobileHeaderMenuProps> = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setIsOpen(false)
  }, [location.pathname, location.search, location.hash, location.key])
  return <Outer>
    <ButtonContainer onClick={() => setIsOpen(isOpen => !isOpen)} >
      {
        isOpen ?
        <SvgCloseIcon /> :
        <SvgMenuIcon />
      }
    </ButtonContainer>
    <MenuOuter open={isOpen}>
      <ItemContainer>
        <Item to="/kitami">
          <DecorationContainer>
            <SvgCircle01 />
          </DecorationContainer>
          <Label>学校法人北見学園</Label>
        </Item>
        <Item to="/muronoki">
          <DecorationContainer>
            <SvgCircle02 />
          </DecorationContainer>
          <Label>室の木幼稚園</Label>
        </Item>
        <Item to="/kids-ami">
          <DecorationContainer>
            <SvgCircle03 />
          </DecorationContainer>
          <Label>プリスクール室の木・キッズアミ</Label>
        </Item>
        <Item to="/grape-seed">
          <DecorationContainer>
            <SvgCircle04 />
          </DecorationContainer>
          <Label>GrapeSEED</Label>
        </Item>
        <Item to="/kosodate">
          <DecorationContainer>
            <SvgCircle05 />
          </DecorationContainer>
          <Label>子育て支援・未就園児</Label>
        </Item>
        <Item to="/staff">
          <DecorationContainer>
            <SvgCircle06 />
          </DecorationContainer>
          <Label>職員紹介</Label>
        </Item>
        <Item to="/advantage">
          <DecorationContainer>
            <SvgCircle07 />
          </DecorationContainer>
          <Label>MURONOKIDSの特徴</Label>
        </Item>
      </ItemContainer>
    </MenuOuter>
  </Outer>
}